"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualHomePersonalPossessionsWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var reactstrap_1 = require("reactstrap");
var commonFunctions_1 = require("../../../commonFunctions");
var services_1 = require("@falcon/services");
var modals = require("./tierTable/TierTableInfoModalRenderers");
var SuggestionModal_1 = require("../../../components/modals/SuggestionModal");
var journey_model_1 = require("@athena-portal/journey-model");
var journey_services_1 = require("@athena-portal/journey-services");
var AnnualHomePersonalPossessionsWidget = exports.AnnualHomePersonalPossessionsWidget = /** @class */ (function (_super) {
    __extends(AnnualHomePersonalPossessionsWidget, _super);
    function AnnualHomePersonalPossessionsWidget(props) {
        var _this = this;
        var _a, _b, _c;
        _this = _super.call(this, props) || this;
        _this.toggleMainPopup = function () {
            _this.setState(function (state) {
                var newShowFlag = !state.showMainPopup;
                var obj = {
                    showMainPopup: newShowFlag
                };
                if (newShowFlag) {
                    obj["initialCoverObject"] = _this.fillInitialCoverObjectFromInteraction();
                }
                return obj;
            });
        };
        _this.renderMainModal = function () {
            var _a;
            var isPremier = _this.props.interaction.coverTier === services_1.GOLD_TIER;
            var closeBtn = React.createElement("button", { className: "btn-close", onClick: function () { return _this.revertPopup(); } });
            var totalValueOfCover = _this.props.interaction.annualHomeExtraCovers ? (_a = _this.props.interaction.annualHomeExtraCovers) === null || _a === void 0 ? void 0 : _a.personalPossessionCoverLimit : undefined;
            return (React.createElement(reactstrap_1.Modal, { className: "my-2 cover-amount-modal annual-home-personal-possessions-modal", isOpen: _this.state.showMainPopup, toggle: function () { return _this.revertPopup(); }, backdrop: true },
                React.createElement(reactstrap_1.ModalHeader, { toggle: function () { return _this.revertPopup(); }, close: closeBtn },
                    React.createElement("div", { className: "d-flex" },
                        React.createElement("div", { className: "text-blue-2 font-weight-medium fs-20" }, "Personal Belongings"))),
                React.createElement(reactstrap_1.ModalBody, { className: "pt-0 overflow-auto", cssModule: { 'modal-body': 'modal-body-no-height-limit' } },
                    React.createElement("div", { className: "mb-3" },
                        React.createElement("p", { className: "m-0" }, "This protects portable items you normally wear, use or carry outside of your home such as your phones, tablets, laptops, cameras, jewellery or the contents of your bag that are worth up to \u00A32000 per item."),
                        React.createElement("p", { className: "font-weight-bold mt-3" }, "What is the total value of cover you would like?"),
                        React.createElement("div", { className: "mr-4 mb-4" },
                            React.createElement("select", { id: _this.props.question.name, className: "form-control width-auto font-weight-bold text-blue-1 mb-3\n                                    ".concat((0, commonFunctions_1.getValidationStyle)(_this.state.isSelectionValid)), onChange: _this.onDropdownChange, onFocus: _this.executeNativeEvent, onClick: _this.executeNativeEvent, onDoubleClick: _this.executeNativeEvent }, _this.renderOptionsList(isPremier, totalValueOfCover)),
                            React.createElement("div", { className: "text-danger fs-14 font-weight-medium mt-md-0" }, _this.state.isSelectionValid === false && "Please select cover amount"))),
                    React.createElement("div", { className: "d-block d-flex alert-close-buttons flex-column" },
                        _this.renderConfirmButton(),
                        _this.renderButtonWithHandler("Cancel", function (e) {
                            _this.revertPopup();
                        }, false, 'btn-white')))));
        };
        _this.renderConfirmButton = function () {
            var _a, _b;
            var totalValueOfCover = _this.props.interaction.annualHomeExtraCovers ? (_a = _this.props.interaction.annualHomeExtraCovers) === null || _a === void 0 ? void 0 : _a.personalPossessionCoverLimit : undefined;
            var itemWasAdded = _this.props.interaction.annualHomeExtraCovers ? (_b = _this.props.interaction.annualHomeExtraCovers) === null || _b === void 0 ? void 0 : _b.personalPossessionsCover : false;
            var noCost = totalValueOfCover === 0;
            var changedCost = totalValueOfCover !== 0 && _this.state.isCoverTotalChanged;
            var itemAddedAndCostChanged = itemWasAdded && _this.state.isCoverTotalChanged;
            var noCover = noCost && _this.state.personalPossessionsCoverWasAddedOnce;
            if (!noCover && (changedCost || itemAddedAndCostChanged)) {
                return _this.renderButton("Add", false, true, !totalValueOfCover);
            }
            else if (noCover) {
                return _this.renderButton("Remove cover", true, true);
            }
            else {
                return _this.renderButton("Add", false, false, true);
            }
        };
        _this.renderButton = function (label, removeCover, closeModal, disabled) {
            if (disabled === void 0) { disabled = false; }
            return _this.renderButtonWithHandler(label, function (e) {
                _this.onButtonClick(e, removeCover, closeModal);
            }, disabled);
        };
        _this.renderButtonWithHandler = function (label, onClick, disabled, className) {
            if (disabled === void 0) { disabled = false; }
            if (className === void 0) { className = 'btn-primary btn-add'; }
            return (React.createElement("button", { type: "button", className: "".concat(disabled ? "btn btn-primary btn-add width-md-250 display-block mb-1 btn-disabled" : "btn width-md-250 display-block mb-1", " ").concat(className), disabled: disabled, onClick: onClick }, label));
        };
        _this.onButtonClick = function (e, removeCover, closeModal) {
            if (_this.state.isSelectionValid) {
                _this.updateCoverObjects(removeCover);
                if (closeModal) {
                    _this.toggleMainPopup();
                    if (!removeCover) {
                        if (!_this.state.initialCoverObject.personalPossessionsCover) {
                            _this.checkAndOpenSuggestionModal();
                        }
                    }
                }
            }
            else {
                e.preventDefault;
            }
            if (removeCover || closeModal) {
                _this.setState({ isCoverTotalChanged: false });
            }
        };
        _this.updateCoverObjects = function (removeCover) {
            var _a;
            var coverLimit = (_a = _this.props.interaction) === null || _a === void 0 ? void 0 : _a.annualHomeExtraCovers.personalPossessionCoverLimit;
            if (removeCover && _this.state.personalPossessionsCoverWasAddedOnce) {
                journey_services_1.ObjectManipulator.setField("annualHomeExtraCovers.personalPossessionsCover", _this.props.interaction, false);
                journey_services_1.ObjectManipulator.setField("annualHomeExtraCovers.personalPossessionCoverLimit", _this.props.interaction, null);
                journey_services_1.ObjectManipulator.setField("annualHomeExtraCovers.personalPossessionsCoverMonthlyPrice", _this.props.interaction, null);
                journey_services_1.ObjectManipulator.setField("annualHomeExtraCovers.personalPossessionsCoverPrice", _this.props.interaction, null);
            }
            else if (coverLimit) {
                journey_services_1.ObjectManipulator.setField("annualHomeExtraCovers.personalPossessionsCover", _this.props.interaction, true);
            }
            _this.executeEvent("change");
        };
        _this.revertPopup = function () {
            _this.toggleMainPopup();
            journey_services_1.ObjectManipulator.setField("annualHomeExtraCovers", _this.props.interaction, _this.state.initialCoverObject);
            _this.setState({
                isCoverTotalChanged: false,
                isSelectionValid: undefined
            });
        };
        _this.onDropdownChange = function (event) {
            var personalPossessionCoverLimit = !isNaN(event.target.value) ? parseInt(event.target.value, 10) : undefined;
            journey_services_1.ObjectManipulator.setField("annualHomeExtraCovers.personalPossessionCoverLimit", _this.props.interaction, personalPossessionCoverLimit);
            _this.setState({ isCoverTotalChanged: true });
            _this.validateSelection();
        };
        _this.state = {
            initialCoverObject: _this.fillInitialCoverObjectFromInteraction(),
            showInfoPopup: false,
            showMainPopup: false,
            isSuggestionModalOpen: false,
            selectedCoverLimit: (_a = _this.props.interaction) === null || _a === void 0 ? void 0 : _a.annualHomeExtraCovers.personalPossessionCoverLimit,
            personalPossessionsCoverWasAddedOnce: !!(((_b = _this.props.interaction.annualHomeExtraCovers) === null || _b === void 0 ? void 0 : _b.personalPossessionsCover) && ((_c = _this.props.interaction) === null || _c === void 0 ? void 0 : _c.annualHomeExtraCovers.personalPossessionCoverLimit) > 0),
            isCoverTotalChanged: false
        };
        _this.toggleInfoPopup = _this.toggleInfoPopup.bind(_this);
        _this.updateCoverObjects = _this.updateCoverObjects.bind(_this);
        _this.renderAddon = _this.renderAddon.bind(_this);
        _this.toggleMainPopup = _this.toggleMainPopup.bind(_this);
        _this.toggleSuggestionModal = _this.toggleSuggestionModal.bind(_this);
        _this.onDropdownChange = _this.onDropdownChange.bind(_this);
        return _this;
    }
    AnnualHomePersonalPossessionsWidget.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            this.renderAddon(),
            this.renderMainModal()));
    };
    AnnualHomePersonalPossessionsWidget.prototype.renderAddon = function () {
        var showTierWarning = this.getSetting("showTierWarning", true);
        var homeCovers = this.props.interaction.annualHomeExtraCovers;
        var valueWording = homeCovers.personalPossessionCoverLimit ?
            (0, commonFunctions_1.getAmountToDisplay)(homeCovers.personalPossessionCoverLimit)
            : (0, commonFunctions_1.getAmountToDisplay)(2000) + " each";
        var selected = !!(homeCovers === null || homeCovers === void 0 ? void 0 : homeCovers.personalPossessionsCover);
        var isAllianz = services_1.resourcesHelper.THEME === "Allianz";
        return (React.createElement("div", { className: "".concat(selected ? "fixed-addon-background-selected quote row mt-2 pb-0 position-relative" : "fixed-addon-background quote row mt-2 pb-0 position-relative") },
            React.createElement("div", { className: "col p-0 d-flex align-items-start fixed-addon-item" },
                !selected &&
                    React.createElement("img", { className: "fixed-addon-icon float-left", src: "/".concat(services_1.resourcesHelper.THEME, "/img/personal-possessions-icon.png"), alt: "addon icon" }),
                selected &&
                    React.createElement("img", { className: "fixed-addon-icon float-left", src: "/".concat(services_1.resourcesHelper.THEME, "/img/fixed-addon-selected-tick.png"), alt: "addon selected icon" }),
                React.createElement("div", { className: "w-100" },
                    React.createElement("div", { className: "heading-info" },
                        React.createElement("p", { className: "font-weight-bold mb-0 heading" }, "Personal Belongings"),
                        isAllianz &&
                            React.createElement("div", { className: "fixed-addon-info cursor-pointer info-button", onClick: this.toggleInfoPopup },
                                this.renderModal(this.state.showInfoPopup),
                                showTierWarning && this.renderSuggestionModal())),
                    React.createElement("p", { className: "mt-0 mb-0" },
                        "Protects items that you carry outside your home worth up to ",
                        React.createElement("span", { className: "font-weight-700" }, valueWording)),
                    React.createElement("p", { className: "mt-0 mb-0 font-weight-bold margin-top-32" },
                        React.createElement("span", { className: "clickable-area", onClick: this.toggleMainPopup }, selected ? "" : "+\u00A0"),
                        React.createElement("span", { className: "blue-link-underline clickable-area", onClick: this.toggleMainPopup }, selected ? "Edit" : "Add")))),
            !isAllianz && React.createElement("div", { className: "fixed-addon-info" },
                React.createElement("img", { className: "fixed-addon-info-icon float-right mr-2 mt-3", src: "/img/Flow-info-white-bg.svg", alt: "Blue info icon", onClick: this.toggleInfoPopup }),
                this.renderModal(this.state.showInfoPopup),
                showTierWarning && this.renderSuggestionModal())));
    };
    AnnualHomePersonalPossessionsWidget.prototype.toggleInfoPopup = function () {
        this.setState(function (state) { return ({
            showInfoPopup: !state.showInfoPopup
        }); });
    };
    AnnualHomePersonalPossessionsWidget.prototype.renderModal = function (isModalOpen) {
        var closeBtn = React.createElement("button", { className: "btn-close", onClick: this.toggleInfoPopup });
        return (React.createElement(React.Fragment, null,
            React.createElement(reactstrap_1.Modal, { className: "my-2 info-modal", isOpen: isModalOpen, toggle: this.toggleInfoPopup },
                React.createElement(reactstrap_1.ModalHeader, { toggle: this.toggleInfoPopup, close: closeBtn },
                    React.createElement("div", { className: "d-flex" },
                        React.createElement("img", { className: "d-block mr-3 mb-1 info-icon-selected", src: "/img/Flow-info-selected.svg", alt: "info selected icon" }),
                        React.createElement("div", { className: "text-blue-2 font-weight-medium" }, "Personal Belongings"))),
                React.createElement(reactstrap_1.ModalBody, { className: "pt-0" },
                    React.createElement("p", null, "This is cover for your items that are worn or carried away from the home (e.g. laptops and jewellery) up to \u00A32,000."),
                    React.createElement("p", null, "You won't list individual item(s) in this section as that should be done under the Specified items section above, instead you choose the level you need from \u00A31,000 up to \u00A315,000. \u00A32,000 is automatically covered under Gold.")),
                React.createElement(reactstrap_1.ModalFooter, { className: "d-flex" },
                    React.createElement("button", { type: "button", className: "btn btn-primary btn-add width-md-250 mb-1", onClick: this.toggleInfoPopup }, "Ok, I understand")))));
    };
    AnnualHomePersonalPossessionsWidget.prototype.renderSuggestionModal = function () {
        var modalTitle = "Because of the changes you've made...";
        return (React.createElement(SuggestionModal_1.SuggestionModal, { title: modalTitle, isSuggestionModalOpen: this.state.isSuggestionModalOpen, toggleSuggestionModal: this.toggleSuggestionModal }, modals.renderFlowPremierSuggestionModal()));
    };
    AnnualHomePersonalPossessionsWidget.prototype.checkAndOpenSuggestionModal = function () {
        if (!this.state.personalPossessionsCoverWasAddedOnce) {
            if (this.props.interaction.annualHomeExtraCovers.personalPossessionCoverLimit > 0) {
                this.setState({ personalPossessionsCoverWasAddedOnce: true });
                this.toggleSuggestionModal();
            }
        }
    };
    AnnualHomePersonalPossessionsWidget.prototype.toggleSuggestionModal = function () {
        this.setState(function (state) { return ({
            isSuggestionModalOpen: !state.isSuggestionModalOpen
        }); });
    };
    AnnualHomePersonalPossessionsWidget.prototype.renderOptionsList = function (isPremier, totalValueOfCover) {
        var options = [];
        var boldClassName = "font-weight-bold";
        if (!isPremier) {
            options.push(React.createElement("option", { className: boldClassName, key: "select", selected: totalValueOfCover === undefined }, "Please select"));
            options.push(React.createElement("option", { className: boldClassName, key: "no-cover", selected: totalValueOfCover === 0, value: 0 }, "No cover"));
        }
        for (var i = isPremier ? 2000 : 1000; i <= 15000; i = i + 500) {
            options.push(React.createElement("option", { className: boldClassName, key: i, selected: totalValueOfCover === i, value: i }, (0, commonFunctions_1.getAmountToDisplay)(i)));
        }
        return options;
    };
    AnnualHomePersonalPossessionsWidget.prototype.fillInitialCoverObjectFromInteraction = function () {
        var _a;
        var annualHomeExtraCovers = (_a = this.props.interaction) === null || _a === void 0 ? void 0 : _a.annualHomeExtraCovers;
        var personalPossessionCoverLimit = annualHomeExtraCovers === null || annualHomeExtraCovers === void 0 ? void 0 : annualHomeExtraCovers.personalPossessionCoverLimit;
        var personalPossessionsCover = annualHomeExtraCovers === null || annualHomeExtraCovers === void 0 ? void 0 : annualHomeExtraCovers.personalPossessionsCover;
        var personalPossessionsCoverMonthlyPrice = annualHomeExtraCovers === null || annualHomeExtraCovers === void 0 ? void 0 : annualHomeExtraCovers.personalPossessionsCoverMonthlyPrice;
        var personalPossessionsCoverPrice = annualHomeExtraCovers === null || annualHomeExtraCovers === void 0 ? void 0 : annualHomeExtraCovers.personalPossessionsCoverPrice;
        return {
            personalPossessionCoverLimit: personalPossessionCoverLimit,
            personalPossessionsCover: personalPossessionsCover,
            personalPossessionsCoverMonthlyPrice: personalPossessionsCoverMonthlyPrice,
            personalPossessionsCoverPrice: personalPossessionsCoverPrice
        };
    };
    AnnualHomePersonalPossessionsWidget.prototype.validateSelection = function () {
        var isSelectionValid = Boolean(this.props.interaction.annualHomeExtraCovers.personalPossessionCoverLimit)
            || Boolean(this.props.interaction.annualHomeExtraCovers.personalPossessionCoverLimit === 0);
        this.setState({
            isSelectionValid: isSelectionValid
        });
    };
    AnnualHomePersonalPossessionsWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "showTierWarning", type: journey_model_1.TypeDescriptions.Boolean }
        ]),
        __metadata("design:paramtypes", [Object])
    ], AnnualHomePersonalPossessionsWidget);
    return AnnualHomePersonalPossessionsWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=AnnualHomePersonalPossessionsWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/home/AnnualHomePersonalPossessionsWidget.js
// module id = 3679
// module chunks = 0